import BizLeaderMobileDashboardTabs from "./BizLeaderMobileComponents/BizLeaderMobileTabs";

const BizLeaderMobileDashboard = () => {
  return (
    <div>
      <BizLeaderMobileDashboardTabs />
    </div>
  );
};

export default BizLeaderMobileDashboard;
